
import { notification } from "antd";

type NotificationType = "success" | "error" | "info" | "warning";
type PlacementType = "topLeft" | "topRight" | "bottomLeft" | "bottomRight";

const visibleToasts = new Set<string>();

const ToastMsg = (
    type: NotificationType,
    description?: string,
    placement: PlacementType = "topRight"
) => {
    const key = `${type}|${placement}|${description}`;
    if (visibleToasts.has(key)) {
        return;
    }
    visibleToasts.add(key);

    if (placement === "topRight") {
        notification.config({
            placement,
            top: 70,
        });
    }

    notification[type]({
        message: ' ',
        description: <span style={{ marginRight: "20px" }}>{description}</span>,
        placement,
        duration: 5,
        onClose: () => {
            visibleToasts.delete(key);
        },
    });
};

export default ToastMsg;
